import { useQuery, UseQueryResult } from 'react-query';
import { GlobalServiceInstruction } from './types';
import { ErrorWithData } from './ErrorWithData';

interface GetProps {
  globalServiceId?: string;
}

async function get({ globalServiceId }: GetProps): Promise<GlobalServiceInstruction[] | undefined> {
  const apiUrl = window.BENCH.auApi.SERVICE_INSTRUCTIONS_API_URL;
  if (!apiUrl)
    throw new Error('Missing required environment variables - SERVICE_INSTRUCTIONS_API_URL');
  if (!globalServiceId) return;

  const response: Response = await fetch(
    `${apiUrl}/global-service-instructions/${globalServiceId}`,
    {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
    },
  );

  if (!response.ok) {
    const error = (await response.json()) as Record<string, unknown>;
    throw new ErrorWithData('Failed to get a global service instruction', error);
  }
  return (await response.json()) as GlobalServiceInstruction[] | undefined;
}

interface GetGlobalServiceInstructionProps {
  globalServiceId: string;
}

export const useFetchServiceInstructions = ({
  globalServiceId,
}: GetGlobalServiceInstructionProps): UseQueryResult<GlobalServiceInstruction[] | undefined> =>
  useQuery({
    // what does the query key string correspond to?
    queryKey: ['getGlobalServiceInstruction', { globalServiceId }],
    queryFn: () => get({ globalServiceId }),
    retry: false,
  });
